import fp from 'lodash/fp';
import React from 'react';
import { FormField } from '.';
import { compose, defaultProps } from 'recompose';

const SelectFormField = ({
  children,
  emptyOption,
  id,
  onChange,
  required,
  value,
  disabled,
  selectStyle,
  ...props
}) => (
    <FormField {...{
      id,
      type: 'select-item',
      ...props
    }}>
      <select {...{
        id,
        name: fp.getOr(fp.camelCase(id))('name')(props),
        value,
        disabled,
        onChange,
        required,
        style: selectStyle,
      }}>
        {
          emptyOption ?
            <option value='' /> :
            null
        }
        {children}
      </select>
    </FormField>
  );

export default compose(
  defaultProps({
    emptyOption: true
  })
)(SelectFormField);



// WEBPACK FOOTER //
// ./src/containers/components/select-form-field.js